import React from 'react';
import { FaChevronDown, FaGlobe, FaCommentAlt } from 'react-icons/fa';

const TruecallerPage: React.FC = () => {
  return (
    <div className=" h-[600px] font-sans">
     
      {/* --- Hero Section --- */}
      <section className="text-white  relative overflow-hidden">
        <div className="container mx-auto px-4 flex flex-col lg:flex-row items-center lg:justify-between">
          {/* Left Side: Phone Images */}
          <div className="relative w-full lg:w-1/2 flex justify-center ">
            <img
              src="https://techsynchron.com/wp-content/uploads/2023/08/how-to-check-last-month-call-history-in-iphone_1692721434.jpg" // Replace with your first phone image path
              alt="COC app on a phone"
              className="w-[500px] mt-12 "
            />
          </div>

          {/* Right Side: Text and CTA */}
          <div className="w-full lg:w-1/2 flex flex-col items-center lg:items-start text-center lg:text-left">
            <p className="text-blue-600 font-semibold mb-2 text-sm">DOWNLOAD TODAY</p>
            <h1 className="text-[#1A237E] text-3xl sm:text-4xl md:text-5xl font-extrabold leading-tight mb-4">
              Trust your communication with COC
            </h1>
            <p className="text-lg sm:text-xl text-gray-800 mb-8 max-w-lg">
              Trusted by over 450 million people. COC is proud to be a leader in caller ID and spam blocking software as well as research around call and SMS harassment.
            </p>
            <button className="bg-[#AEEA00] text-[#1A237E] hover:bg-lime-600 font-bold py-3 px-8 rounded-full transition-colors duration-300 shadow-lg">
              Try COC for Free
            </button>
          </div>
        </div>
      </section>

      {/* --- Bottom Chat Bubble ---
      <div className="fixed bottom-4 right-4 z-50">
        <button className="bg-white text-gray-700 rounded-full py-2 px-4 shadow-lg text-sm flex items-center space-x-2">
          <span>Talk to me!</span>
          <FaCommentAlt className="text-blue-500" />
        </button>
      </div> */}

     
    </div>
  );
};

export default TruecallerPage;